export const TOOLTIP_TEXT_KEYS = {
  VACATION_INFO: [
    'vacation.vacation_data.info_sign_text.vacation_days_left',
    'vacation.vacation_data.info_sign_text.accumulated_days',
    'vacation.vacation_data.info_sign_text.days_to_burn',
  ],
} as const;

export type TooltipTextKey = keyof typeof TOOLTIP_TEXT_KEYS;
